import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLightLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m27.464 35.746 1.431-1.43a.867.867 0 0 0 0-1.227L15.837 20 28.895 6.911a.867.867 0 0 0 0-1.226l-1.43-1.431a.867.867 0 0 0-1.227 0L11.105 19.387a.867.867 0 0 0 0 1.226l15.133 15.133a.867.867 0 0 0 1.226 0Z" })
});
export default SvgChevronLightLeft;
